import React, { useState } from 'react';
import RadioPlayer from './components/RadioPlayer';
import ContactInfo from './components/ContactInfo';

const App = () => {
  const streamUrl = "https://radio.mipanel.stream:6714/;";
  const whatsappNumber = "56945539984";
  const websiteUrl = "https://www.tele2web.cl";
  const logoUrl = "https://4tsix0yujj.ufs.sh/f/2vMRHqOYUHc0Ybr8C2HLxysUGcrlHAMdQ0Ba6XFOPIJgkW1b";

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <img src={logoUrl} alt="Tele2Web Radio Logo" className="w-40 h-40 object-contain mb-8" />
      <RadioPlayer streamUrl={streamUrl} />
      <ContactInfo whatsappNumber={whatsappNumber} websiteUrl={websiteUrl} />
    </div>
  );
};

export default App;

// DONE